import React from "react";
import "./Categories.css";

function Categories() {
  return (
    <div className="categories">
      <p>Men</p>
      <p>Women</p>
      <p>Kids</p>
      <p>Accessories</p>
    </div>
  );
}

export default Categories;
